function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Mobile app");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M809.69164,503.89989,617.02788,263.14232a64.6863,64.6863,0,0,1-31.15834,15.733c-36.27094,7.14326-71.69282-17.62565-79.117-55.32291-5.24805-26.64771,4.91144-52.60794,24.12256-68.06873L465.18227,73.39221l-374.2591,319.862L435.43248,823.76189Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#f2f2f2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 82.15365,
  y1: 752.56388,
  x2: 970.15365,
  y2: 752.56388,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 619.42905,
  cy: 56.91588,
  r: 14.75556,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 814.42905,
  cy: 485.91588,
  r: 14.75556,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 170.69572,
  cy: 93.91588,
  r: 14.75556,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 479.37657,
  cy: 139.7294,
  r: 54.31516,
  fill: "#f2f2f2"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M247.8073,182.77181H488.42279a51.15011,51.15011,0,0,1,49.89774,39.90061l121.57825,539.2673A41.34031,41.34031,0,0,1,621.605,812.322L374.25065,824.50915a54.6149,54.6149,0,0,1-56.43046-44.82745l-68.9666-381.268-5.13081,1.466-13.19613-72.26456,5.28146-1.32036-19.251-106.42558A31.49278,31.49278,0,0,1,247.8073,182.77181Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#3f3d56"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M456.74614,194.397h28.08708a35.34864,35.34864,0,0,1,34.53619,27.81348L636.06778,757.078a21.90325,21.90325,0,0,1-19.96738,26.52542L369.54623,799.76236a28.36685,28.36685,0,0,1-29.77274-23.27749L240.194,223.64717A24.84574,24.84574,0,0,1,264.64627,194.397h26.645a11.72583,11.72583,0,0,1,11.32265,8.67742v0a10.35184,10.35184,0,0,0,9.9959,7.66063H439.103a17.69522,17.69522,0,0,0,17.6431-16.33806Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#4527a0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 189.24608,
  y: 259.25001,
  width: 255.12532,
  height: 1.25677,
  fill: "#2f2e41"
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 196.78673,
  y: 300.0952,
  width: 257.63887,
  height: 1.25677,
  fill: "#2f2e41"
});

var _ref13 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "205.357 257.26 211.154 249.531 210.149 248.777 205.139 255.457 185.833 239.661 185.038 240.635 205.357 257.26",
  fill: "#2f2e41"
});

var _ref14 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "238.662 439.492 244.459 431.763 243.454 431.01 238.443 437.689 219.137 421.894 218.342 422.867 238.662 439.492",
  fill: "#2f2e41"
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 306.53159,
  y: 515.81703,
  width: 267.12456,
  height: 1.25706,
  transform: "translate(-101.75857 -63.95891) rotate(-1.21314)",
  fill: "#2f2e41"
});

var _ref16 =
/*#__PURE__*/
React.createElement("rect", {
  x: 309.66719,
  y: 553.20606,
  width: 272.16433,
  height: 1.25712,
  transform: "translate(-103.59158 -62.95288) rotate(-1.32299)",
  fill: "#2f2e41"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M414.95837,657.20436a59.69681,59.69681,0,0,0,119.39362,0c0-.74775-.01258-1.48928-.044-2.23081a59.69562,59.69562,0,0,0-119.34959,2.23081Z",
  transform: "translate(-90.92317 -73.39221)",
  opacity: 0.1
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M420.61386,680.4547c0,.74774.01258,1.48927.044,2.2308A59.7041,59.7041,0,0,0,534.352,657.20436c0-.74775-.01258-1.48928-.044-2.23081a59.7041,59.7041,0,0,0-113.6941,25.48115Z",
  transform: "translate(-90.92317 -73.39221)",
  opacity: 0.1
});

var _ref19 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 692.9535,
  cy: 234.91667,
  r: 36.79985,
  fill: "#2f2e41"
});

var _ref20 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "732.654 696.064 739.654 726.064 722.654 726.064 715.654 692.064 732.654 696.064",
  fill: "#9f616a"
});

var _ref21 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "650.654 696.064 650.654 724.064 633.654 726.064 633.654 696.064 650.654 696.064",
  fill: "#9f616a"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M828.57683,451.4561s-2,43-4,46-20,46-20,46l-9-28s14-23,12-36-.74-28.99711-.74-28.99711Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#9f616a"
});

var _ref23 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 680.65365,
  cy: 246.06388,
  r: 28,
  fill: "#9f616a"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M794.57683,322.4561s-1,40,6,46-40,1-40,1,10-28,2-34S794.57683,322.4561,794.57683,322.4561Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#9f616a"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M757.57683,367.4561s6-11,14-10,34,3,35,5,4,9,6,11,17,5,18,17-36,85-36,85,5,17,4,21,5,16,4,21,15,35,7,74v63s27,109,19,117-35,3-40,0-26-154-26-154l-10-51-1,112s2,94-5,97-34,4-36-2c-1.55984-4.67951-9.2024-129.18869-12.49082-183.76644a203.905,203.905,0,0,1,4.40284-56.17549c4.16209-18.87768,10.20448-41.05657,17.088-50.05807,13-17,21-71,21-71l-17-31s10-10,16-10S757.57683,367.4561,757.57683,367.4561Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#2f2e41"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M824.57683,383.4561l5.27357,3.58937s3.72643,64.41063.72643,68.41063-23.85728,2.04776-25.42864-1.47612S824.57683,383.4561,824.57683,383.4561Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#2f2e41"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M735.40019,442.01963c2.92713,20.30658,5.49231,38.38334-9.47485,54.73713a280.86164,280.86164,0,0,1-50.53357,43.77194c-1.83569,4.86276-28.78522,40.57217-30.15613,26.32809s7.94006-25.41089,21.17151-37.45617,31.74237-38.18036,42.18689-52.5207,6.14465-23.28283,5.78186-35.261S731.29344,442.16459,735.40019,442.01963Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#9f616a"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M724.57683,781.25531s-1,11.20079-4,14.20079-11,7-10,18,7.5,11.5,7.5,11.5l-.5-2.5,3,1,.5,1.5h28s.5-10.5-.5-15.5-1-29-4-28-11,2-13,6S723.57683,790.05452,724.57683,781.25531Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#2f2e41"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M826.57683,781.25531s1,11.20079,4,14.20079,11,7,10,18-7.5,11.5-7.5,11.5l.5-2.5-3,1-.5,1.5h-28s-.5-10.5.5-15.5,1-29,4-28,11,2,13,6S827.57683,790.05452,826.57683,781.25531Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#2f2e41"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M737.57683,378.4561l-14,3s0,22-4,31-11,30-8,31,31,15,33,7S751.57683,378.4561,737.57683,378.4561Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#2f2e41"
});

var _ref31 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 732.82,
  cy: 186.46354,
  r: 36.79985,
  fill: "#2f2e41"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M855.485,290.32839a36.80185,36.80185,0,0,1-56.82871-19.323,36.80188,36.80188,0,1,0,71.78659-15.09134A36.78829,36.78829,0,0,1,855.485,290.32839Z",
  transform: "translate(-90.92317 -73.39221)",
  fill: "#2f2e41"
});

var _ref33 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 702.76678,
  cy: 241.04997,
  r: 26.98656,
  fill: "#2f2e41"
});

var _ref34 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 680.07355,
  cy: 230.93,
  rx: 23.9199,
  ry: 18.70659,
  fill: "#2f2e41"
});

var _ref35 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 673.69343,
  cy: 250.09857,
  rx: 4.53977,
  ry: 8.03191,
  fill: "#a0616a"
});

var SvgUndrawMobileAppP3Ts = function SvgUndrawMobileAppP3Ts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "f8de8b25-3d53-474b-a5b1-b2a4ad6ddbb8",
    "data-name": "Layer 1",
    width: 970.15365,
    height: 753.56388,
    viewBox: "0 0 970.15365 753.56388",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawMobileAppP3Ts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_Mobile_app_p3ts.0b3900f5.svg";
export { ForwardRef as ReactComponent };